const HoorayIcon = () => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.36845 15.4837H7.10191C7.3443 15.4837 7.54044 15.2876 7.54044 15.0452V14.5722C7.54088 13.893 7.88346 13.2077 8.48133 12.7426C9.29803 12.1079 9.73142 11.5045 9.80723 10.8981C9.88731 10.2553 9.65734 9.86943 9.4505 9.65917C9.30645 9.51302 8.99278 9.41329 8.71712 9.53021C8.52536 9.61148 8.38266 9.77783 8.33135 9.97971C8.04765 11.0962 7.08966 11.9169 5.87673 11.9169C4.42354 11.9169 3.24552 10.7389 3.24552 9.28574C3.24552 7.83255 4.42354 6.65453 5.87673 6.65453C6.69647 6.65453 7.42441 7.03129 7.90463 7.61992C8.12755 7.89316 8.49809 7.99662 8.83032 7.87848C9.1625 7.76034 9.38492 7.44606 9.38501 7.09306C9.38501 5.55264 6.87542 4.90039 5.87673 4.90039C4.70716 4.90039 3.60655 5.35691 2.77702 6.18603C1.26732 7.69655 1.52871 9.50936 1.49696 9.69644C1.49053 10.9709 1.48197 12.7745 1.93763 15.1274C1.97701 15.3342 2.15816 15.4837 2.36845 15.4837Z"
        fill="white"
      />
      <path
        d="M7.41086 4.26523C8.19937 3.56177 7.91947 3.83135 8.34596 3.47841C8.72143 3.18012 8.79195 2.62886 8.48684 2.24505C8.19434 1.87762 7.62047 1.81336 7.25561 2.10457C7.05611 2.27695 6.31405 2.77421 5.13281 4.08231C5.37766 4.04766 5.62508 4.02401 5.87666 4.02401C6.30402 4.02401 6.85047 4.10394 7.41086 4.26523Z"
        fill="white"
      />
      <path
        d="M4.95446 0.605523C4.53221 0.391372 3.98746 0.574679 3.7772 0.997807C3.63105 1.34475 2.75693 2.68921 2.20923 5.51925C2.62321 5.11626 3.09235 4.79245 3.59807 4.54827C3.95679 4.0991 4.31721 3.67468 4.6814 3.28395C5.08713 2.21363 5.16457 2.17293 5.34674 1.78065C5.56709 1.3382 5.37764 0.816224 4.95446 0.605523Z"
        fill="white"
      />
      <path
        d="M1.09231 7.12598C1.23504 5.68189 1.52549 4.28471 1.97365 2.97671C1.94751 2.5953 1.92503 2.21354 1.93564 1.83038L1.94678 1.41711C1.96043 0.949774 1.60227 0.529073 1.0693 0.515625C0.590069 0.515625 0.205504 0.890777 0.193517 1.36913L0.182378 1.78282C0.132151 3.60189 0.393401 5.76737 0.901751 7.63205C0.956977 7.45842 1.02048 7.28973 1.09231 7.12598Z"
        fill="white"
      />
    </svg>
  );
};
const DiscountStrip = ({ discount }) => {
  if (!discount) {
    return null;
  }

  return (
    <div className="tw-my-8 tw-flex tw-w-full tw-max-w-[500px] tw-justify-center tw-gap-2 tw-rounded tw-bg-[#1E6A26] tw-py-[6px] tw-text-white">
      <div className="tw-flex tw-items-center tw-justify-center">
        <HoorayIcon />
      </div>
      <div className="tw-flex tw-items-center tw-text-[14px] tw-font-medium tw-leading-[18px]">
        Great! You're saving ₹{discount} on this order!
      </div>
    </div>
  );
};

export default DiscountStrip;
